import React from 'react';
import * as R from 'ramda';
import {mapWithIndex, toDollar, maybe} from '@/util';
import download from '@/assets/images/download.png';
import {useTranslation} from 'react-i18next';
import {totalValuation} from '@/b2c/PlanDetail/Detail/PlanHolding';

const holdingTypeConvert = R.cond([
  [R.equals('I'), R.always('holding_type_I')],
  [R.equals('A'), R.always('holding_type_A')],
  [R.T, R.always('holding_type_C')],
]);

const onOffFundCode = R.compose(
  R.not,
  R.equals('FD')
);

const itemList = productCategory =>
  mapWithIndex((item, idx) => (
    <tr key={`investment_holding_${idx}`}>
      {maybe(onOffFundCode(productCategory)).map(() => (
        <td key={`item_code_${idx}`}>{item.code}</td>
      ))}
      <td>
        {item.description}
        {maybe(item.factsheetPath !== '').map(() => (
          <button
            type='button'
            className='btn btn-link btn-sm'
            onClick={() => {
              window.open(item.factsheetPath);
            }}
          >
            <img alt='Download' src={download} />
          </button>
        ))}
      </td>
      <td>{toDollar(item.unitHeld, 4)}</td>
      <td>{item.currency}</td>
      <td>{toDollar(item.price, 4)}</td>
      <td>{item.valueOn}</td>
      <td>{toDollar(item.value)}</td>
      <td>{toDollar(item.valuationValue)}</td>
    </tr>
  ));

const itemListRwd = (productCategory, planCurrency, tr) =>
  mapWithIndex((item, idx) => (
    <li key={idx}>
      <strong>
        {item.description}
        {maybe(item.factsheetPath !== '').map(() => (
          <button
            type='button'
            className='btn btn-link btn-sm'
            onClick={() => {
              window.open(item.factsheetPath);
            }}
          >
            <img alt='Download' src={download} />
          </button>
        ))}
      </strong>
      <table>
        <tbody>
          {maybe(onOffFundCode(productCategory)).map(() => (
            <tr key={`fund_code_${idx}`}>
              <td>{tr('fund_code')}</td>
              <td>{item.code}</td>
            </tr>
          ))}
          <tr>
            <td>{tr('unit_balance')}</td>
            <td>
              <strong>{toDollar(item.unitHeld, 4)}</strong>
            </td>
          </tr>
          <tr>
            <td>
              {tr('valuation_date')} / {tr('unit_price')}
            </td>
            <td>
              {item.valueOn} / {toDollar(item.price, 4)}
            </td>
          </tr>
          <tr>
            <td>
              {tr('in_fund_currency')} ({item.currency})
            </td>
            <td>{toDollar(item.value)}</td>
          </tr>
          <tr>
            <th>
              {tr('in_plan_currency')} ({planCurrency})
            </th>
            <th>{toDollar(item.valuationValue)}</th>
          </tr>
        </tbody>
      </table>
    </li>
  ));

const InvestmentHolding = ({planCurrency, type, data, productCategory}) => {
  const {t: tr} = useTranslation('statements');

  return (
    <section className='plan-details'>
      <h5>{tr(holdingTypeConvert(type))}</h5>

      {/* wide */}
      <table className='wide list text-left'>
        <tbody>
          <tr>
            {maybe(onOffFundCode(productCategory)).map(() => (
              <th key='fund_code_wide'>{tr('fund_code')}</th>
            ))}
            <th>{tr('fund_name')}</th>
            <th>{tr('unit_balance')}</th>
            <th>{tr('fund_currency')}</th>
            <th>{tr('unit_price')}</th>
            <th>{tr('valuation_date')}</th>
            <th>{tr('in_fund_currency')}</th>
            <th>
              {tr('in_plan_currency')}({planCurrency})
            </th>
          </tr>
          {itemList(productCategory)(data)}
        </tbody>
      </table>

      {/* RWD */}
      <ul className='narrow list'>
        {itemListRwd(productCategory, planCurrency, tr)(data)}
      </ul>

      <div className='subtotal clearfix'>
        <div className='name'>
          {type === 'I' && <p>{tr('i_sub_total')}:</p>}
          {type === 'A' && <p>{tr('a_sub_total')}:</p>}
          {type === '' && <p>{tr('sub_total')}:</p>}
        </div>
        <div className='number'>
          <p>{toDollar(totalValuation(data))}</p>
        </div>
      </div>
    </section>
  );
};

export default InvestmentHolding;
